const defaultPm2PrintChunkClassName = "_7cd7vnh2s";

export { defaultPm2PrintChunkClassName };
import "./pm2.chunk.style.linaria.module.css";
//# sourceMappingURL=pm2.chunk.style.js.map
